import { FetchStatus } from '@flatsy/types/FetchStatus'
import { createSlice } from '@reduxjs/toolkit'
import { fetchQualification } from './Actions'
import { initialQualificationConfig } from './Constant'
import { QualificationConfigState } from './Type'

export const initialState: QualificationConfigState = {
  status: FetchStatus.IDLE,
  config: initialQualificationConfig,
}

export const qualificationConfigSlice = createSlice({
  name: 'qualificationConfig',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchQualification.pending, (state) => {
        state.status = FetchStatus.LOADING
      })
      .addCase(fetchQualification.fulfilled, (state, action) => {
        state.status = FetchStatus.SUCCEEDED
        state.config = action.payload
      })
      .addCase(fetchQualification.rejected, (state, action) => {
        if (action.payload?.code === 404) {
          state.status = FetchStatus.NOT_FOUND
        } else {
          state.status = FetchStatus.FAILED
        }
      })
  },
})
